// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1vutw","col":"CardReaderDesc_col__Y5Ahc","label":"CardReaderDesc_label__3deHz"};